export const KBA_CLASSIFICATION_GLOBAL_ID = 1
export const KBA_CLASSIFICATION_REGIONAL_ID = 2
export const KBA_CLASSIFICATION_GLOBAL_REGIONAL_ID = 3

export const kbaClassificationList = [
  {id: KBA_CLASSIFICATION_GLOBAL_ID, name: 'global'},
  {id: KBA_CLASSIFICATION_REGIONAL_ID, name: 'regional'},
  {id: KBA_CLASSIFICATION_GLOBAL_REGIONAL_ID, name: 'global / regional tbd'}
]
